import { LoggerType } from '@app/core/enums/logger-type.enum';
import { DeviceStatus } from '@app/core/enums/device-status.enum';
import { ILoggerDeploymentData } from '@app/api/interfaces/logger-deployment-data.interface';
import { altTestAreaId, testAreaId, testMarkersAreaId } from '@mock/data/areas-mock.data';
import { altTestProjectId, testProjectId } from './projects-mock.data';
import { LoggerEcl } from '@app/core/enums/logger-ecl.enum';
import { CommonStateStatus } from '@app/core/enums/common-state-status.enum';
import { coordinateSystemForProject } from '@mock/data/coordinate-systems-mock.data';

const testProjectCoordinateSystemId = coordinateSystemForProject(testProjectId).id;
const altTestProjectCoordinateSystemId = coordinateSystemForProject(altTestProjectId).id;

export const loggerDeploymentsDataMockData: ILoggerDeploymentData[] = [
  {
    deploymentId: 'ld00001',
    serialNo: 'log00001',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: '__some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 43351.5074,
      axis2: -7565.1278,
    },
    coordinates: {
      lat: 15.1757280048674,
      lon: 145.7727444232052,
    },
    adjustedCoordinates: {
      lat: 15.1757280048674,
      lon: 145.7727444232052,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: '__some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247202',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value0,
    roundTripTime: 320,
    usedBandForMeasurement: 3,
  },
  {
    deploymentId: 'ld00001a',
    serialNo: 'log00001',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: '__some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 43351.5074,
      axis2: -7565.1278,
    },
    coordinates: {
      lat: 15.17662627115936,
      lon: 145.7734252728056,
    },
    adjustedCoordinates: {
      lat: 15.17662627115936,
      lon: 145.7734252728056,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: '__some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247202',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00002',
    serialNo: 'log00002',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    coordinates: {
      lat: 15.17632691148176,
      lon: 145.7726680512708,
    },
    adjustedCoordinates: {
      lat: 15.17632691148176,
      lon: 145.7726680512708,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247203',
    loggerType: LoggerType.NBIOT,
    eclForMeasurement: LoggerEcl.Value1,
    isPositionTemporary: true,
  },
  {
    deploymentId: 'ld000036',
    serialNo: 'log000036',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 51.5074,
      axis2: -65665.1278,
    },
    coordinates: {
      lat: 15.176364286715094,
      lon: 145.7734888809107,
    },
    adjustedCoordinates: {
      lat: 15.176364286715094,
      lon: 145.7734888809107,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247203',
    loggerType: LoggerType.NBIOT,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00003',
    serialNo: 'log00003',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17578520919731,
      lon: 145.7735941521255,
    },
    adjustedCoordinates: {
      lat: 15.17583520919731,
      lon: 145.7735641521255,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247204',
    loggerType: LoggerType.ZS_HYDRO,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00004',
    serialNo: 'log00004',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17785487540812,
      lon: 145.773393086249,
    },
    adjustedCoordinates: {
      lat: 15.17785487540812,
      lon: 145.773393086249,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247205',
    loggerType: LoggerType.ZS820,
  },
  {
    deploymentId: 'ld00005',
    serialNo: 'log00005',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17770637492032,
      lon: 145.7743032242437,
    },
    adjustedCoordinates: {
      lat: 15.17770637492032,
      lon: 145.7743032242437,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247206',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00006',
    serialNo: 'log00006',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.1771352128409,
      lon: 145.7743641101827,
    },
    adjustedCoordinates: {
      lat: 15.1771352128409,
      lon: 145.7743641101827,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247207',
    loggerType: LoggerType.ZS820,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00007',
    serialNo: 'log00007',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.176146722618,
      lon: 145.7747301050062,
    },
    adjustedCoordinates: {
      lat: 15.176146722618,
      lon: 145.7747301050062,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247208',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00008',
    serialNo: 'log00008',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17565886232308,
      lon: 145.7758060050823,
    },
    adjustedCoordinates: {
      lat: 15.17565886232308,
      lon: 145.7758060050823,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247209',
    loggerType: LoggerType.HISCAN,
  },
  {
    deploymentId: 'ld00009',
    serialNo: 'log00009',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17753419383122,
      lon: 145.7757060923942,
    },
    adjustedCoordinates: {
      lat: 15.17753419383122,
      lon: 145.7757060923942,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247210',
    loggerType: 'EASYSCAN' as LoggerType,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00010',
    serialNo: 'log000010',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17730822750462,
      lon: 145.7760180218253,
    },
    adjustedCoordinates: {
      lat: 15.17730822750462,
      lon: 145.7760180218253,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247202',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00011',
    serialNo: 'log000011',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17677652337259,
      lon: 145.776250439588,
    },
    adjustedCoordinates: {
      lat: 15.17677652337259,
      lon: 145.776250439588,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247212',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00012',
    serialNo: 'log000012',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17644895217386,
      lon: 145.7754618388461,
    },
    adjustedCoordinates: {
      lat: 15.17644895217386,
      lon: 145.7754618388461,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247213',
    loggerType: LoggerType.ZS_AI,
  },
  {
    deploymentId: 'ld00013',
    serialNo: 'log000013',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17887673500088,
      lon: 145.7726241736576,
    },
    adjustedCoordinates: {
      lat: 15.17887673500088,
      lon: 145.7726241736576,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247214',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00014',
    serialNo: 'log000014',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17525188131608,
      lon: 145.7750853003925,
    },
    adjustedCoordinates: {
      lat: 15.17525188131608,
      lon: 145.7750853003925,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247215',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00015',
    serialNo: 'log000015',
    projectId: testProjectId,
    areaId: testAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17690095231235,
      lon: 145.7751008149355,
    },
    adjustedCoordinates: {
      lat: 15.17690095231235,
      lon: 145.7751008149355,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247216',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00016',
    serialNo: 'log000016',
    projectId: altTestProjectId,
    areaId: altTestAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: altTestProjectCoordinateSystemId,
      axis1: 2043351.51,
      axis2: 1406565.13,
    },
    coordinates: {
      lat: 50.61060526418324,
      lon: -1.9738774157691963,
    },
    adjustedCoordinates: {
      lat: 50.61060526418324,
      lon: -1.9738774157691963,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247217',
    loggerType: LoggerType.ZS_AI,
  },
  {
    deploymentId: 'ld00017',
    serialNo: 'log000017',
    projectId: altTestProjectId,
    areaId: altTestAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: altTestProjectCoordinateSystemId,
      axis1: 2043498.72,
      axis2: 1406702.44,
    },
    coordinates: {
      lat: 50.61171207686727,
      lon: -1.9747577338281652,
    },
    adjustedCoordinates: {
      lat: 50.61171207686727,
      lon: -1.9747577338281652,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247218',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value0,
  },
  // loggers for displaying different types and statuses
  {
    deploymentId: 'ld00001test',
    serialNo: 'log00001test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16917087188439,
      lon: 145.7711623116807,
    },
    adjustedCoordinates: {
      lat: 15.16917087188439,
      lon: 145.7711623116807,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247219',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00002test',
    serialNo: 'log00002test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16940071340622,
      lon: 145.771581037372,
    },
    adjustedCoordinates: {
      lat: 15.16940071340622,
      lon: 145.771581037372,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247220',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00003test',
    serialNo: 'log00003test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16954473621365,
      lon: 145.771864060543,
    },
    adjustedCoordinates: {
      lat: 15.16954473621365,
      lon: 145.771864060543,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247221',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00004test',
    serialNo: 'log00004test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17007691273117,
      lon: 145.7729484837745,
    },
    adjustedCoordinates: {
      lat: 15.17007691273117,
      lon: 145.7729484837745,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247222',
    loggerType: LoggerType.ZS_AI,
  },
  {
    deploymentId: 'ld00005test',
    serialNo: 'log00005test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17049985858921,
      lon: 145.7742887021378,
    },
    adjustedCoordinates: {
      lat: 15.17049985858921,
      lon: 145.7742887021378,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247223',
    loggerType: LoggerType.NBIOT,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00006test',
    serialNo: 'log00006test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17053684640716,
      lon: 145.7747319752937,
    },
    adjustedCoordinates: {
      lat: 15.17053684640716,
      lon: 145.7747319752937,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247224',
    loggerType: LoggerType.NBIOT,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00007test',
    serialNo: 'log00007test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17060257572335,
      lon: 145.77551972139,
    },
    adjustedCoordinates: {
      lat: 15.17060257572335,
      lon: 145.77551972139,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247202',
    loggerType: LoggerType.NBIOT,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00008test',
    serialNo: 'log00008test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17062382215105,
      lon: 145.7757743605998,
    },
    adjustedCoordinates: {
      lat: 15.17062382215105,
      lon: 145.7757743605998,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247225',
    loggerType: LoggerType.NBIOT,
  },
  {
    deploymentId: 'ld00009test',
    serialNo: 'log00009test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16864616870803,
      lon: 145.7718333315579,
    },
    adjustedCoordinates: {
      lat: 15.16864616870803,
      lon: 145.7718333315579,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247226',
    loggerType: LoggerType.ZS_HYDRO,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00010test',
    serialNo: 'log000010test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16887930238451,
      lon: 145.7722782126039,
    },
    adjustedCoordinates: {
      lat: 15.16887930238451,
      lon: 145.7722782126039,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247227',
    loggerType: LoggerType.ZS_HYDRO,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00011test',
    serialNo: 'log000011test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16903923629887,
      lon: 145.7725834105796,
    },
    adjustedCoordinates: {
      lat: 15.16903923629887,
      lon: 145.7725834105796,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247228',
    loggerType: LoggerType.ZS_HYDRO,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00012test',
    serialNo: 'log000012test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16925595050759,
      lon: 145.7729969630012,
    },
    adjustedCoordinates: {
      lat: 15.16925595050759,
      lon: 145.7729969630012,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247229',
    loggerType: LoggerType.ZS_HYDRO,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00013test',
    serialNo: 'log000013test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16959446242607,
      lon: 145.7736461244334,
    },
    adjustedCoordinates: {
      lat: 15.16959446242607,
      lon: 145.7736461244334,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247230',
    loggerType: LoggerType.ZS820,
  },
  {
    deploymentId: 'ld00014test',
    serialNo: 'log000014test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16971245364962,
      lon: 145.7738942314904,
    },
    adjustedCoordinates: {
      lat: 15.16971245364962,
      lon: 145.7738942314904,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247231',
    loggerType: LoggerType.ZS820,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00015test',
    serialNo: 'log000015test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16974224659706,
      lon: 145.7745153035117,
    },
    adjustedCoordinates: {
      lat: 15.16979224659706,
      lon: 145.7745553035117,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247232',
    loggerType: LoggerType.ZS820,
  },
  {
    deploymentId: 'ld00016test',
    serialNo: 'log000016test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16992206040949,
      lon: 145.7750326964669,
    },
    adjustedCoordinates: {
      lat: 15.16982206040949,
      lon: 145.7749326964669,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247233',
    loggerType: LoggerType.ZS820,
  },
  {
    deploymentId: 'ld00017test',
    serialNo: 'log000017test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16826981614067,
      lon: 145.7723528534077,
    },
    adjustedCoordinates: {
      lat: 15.16826981614067,
      lon: 145.7723528534077,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247234',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00018test',
    serialNo: 'log000018test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16824102495047,
      lon: 145.7726674455932,
    },
    adjustedCoordinates: {
      lat: 15.16824102495047,
      lon: 145.7726674455932,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247235',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value1,
  },
  {
    deploymentId: 'ld00019test',
    serialNo: 'log000019test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16825797421938,
      lon: 145.772875153366,
    },
    adjustedCoordinates: {
      lat: 15.16825797421938,
      lon: 145.772875153366,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247236',
    loggerType: LoggerType.ZS850,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00020test',
    serialNo: 'log000020test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16829056889139,
      lon: 145.7732745971433,
    },
    adjustedCoordinates: {
      lat: 15.16829056889139,
      lon: 145.7732745971433,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247237',
    loggerType: LoggerType.ZS850,
  },
  {
    deploymentId: 'ld00021test',
    serialNo: 'log000021test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16835010708687,
      lon: 145.7740006390867,
    },
    adjustedCoordinates: {
      lat: 15.16835010708687,
      lon: 145.7740006390867,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247238',
    loggerType: LoggerType.MULTISCAN,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00022test',
    serialNo: 'log000022test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16841284611166,
      lon: 145.7747607003985,
    },
    adjustedCoordinates: {
      lat: 15.16841284611166,
      lon: 145.7747607003985,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247239',
    loggerType: LoggerType.MULTISCAN,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00023test',
    serialNo: 'log000023test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16848044394394,
      lon: 145.7755796597163,
    },
    adjustedCoordinates: {
      lat: 15.16848044394394,
      lon: 145.7755796597163,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247240',
    loggerType: LoggerType.MULTISCAN_2,
    eclForMeasurement: LoggerEcl.Value2,
  },
  {
    deploymentId: 'ld00024test',
    serialNo: 'log000024test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16851295744515,
      lon: 145.77597357938,
    },
    adjustedCoordinates: {
      lat: 15.16851295744515,
      lon: 145.77597357938,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Ok,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247241',
    loggerType: LoggerType.MULTISCAN_2,
    eclForMeasurement: LoggerEcl.Value1,
  },
  // free ids
  {
    deploymentId: 'ld00029test',
    serialNo: 'log000029test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.17236583388106,
      lon: 145.7773756980471,
    },
    adjustedCoordinates: {
      lat: 15.17236583388106,
      lon: 145.7773756980471,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Error,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247246',
    loggerType: LoggerType.ZS_AI,
    eclForMeasurement: LoggerEcl.Value0,
  },
  {
    deploymentId: 'ld00030test',
    serialNo: 'log000030test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.1718966717539,
      lon: 145.7771126588061,
    },
    adjustedCoordinates: {
      lat: 15.1719966717539,
      lon: 145.7772126588061,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.ZS_AI,
  },
  // new
  {
    deploymentId: 'ld00031test',
    serialNo: 'log000031test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16752866567823,
      lon: 145.7724125388834,
    },
    adjustedCoordinates: {
      lat: 15.16752866567823,
      lon: 145.7724125388834,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.ZS820_AMI,
  },
  {
    deploymentId: 'ld00032test',
    serialNo: 'log000032test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16754172302937,
      lon: 145.7728725619363,
    },
    adjustedCoordinates: {
      lat: 15.16754172302937,
      lon: 145.7728725619363,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.ZS820_AMI,
  },
  {
    deploymentId: 'ld00033test',
    serialNo: 'log000033test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16758149147221,
      lon: 145.7733535550187,
    },
    adjustedCoordinates: {
      lat: 15.16758149147221,
      lon: 145.7733535550187,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.ZS820_AMI,
  },
  {
    deploymentId: 'ld00034test',
    serialNo: 'log000034test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16766138021175,
      lon: 145.7736841287412,
    },
    adjustedCoordinates: {
      lat: 15.16766138021175,
      lon: 145.7736841287412,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.ZS820_AMI,
  },
  {
    deploymentId: 'ld00035test',
    serialNo: 'log000035test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.1677892461001,
      lon: 145.7743250369716,
    },
    adjustedCoordinates: {
      lat: 15.1677892461001,
      lon: 145.7743250369716,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.HISCAN,
  },
  {
    deploymentId: 'ld00036test',
    serialNo: 'log000036test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16768937658091,
      lon: 145.7743341850594,
    },
    adjustedCoordinates: {
      lat: 15.16768937658091,
      lon: 145.7743341850594,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.HISCAN,
  },
  {
    deploymentId: 'ld00037test',
    serialNo: 'log000037test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16784208839168,
      lon: 145.7750576553423,
    },
    adjustedCoordinates: {
      lat: 15.16784208839168,
      lon: 145.7750576553423,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.HISCAN,
  },
  {
    deploymentId: 'ld00038test',
    serialNo: 'log000038test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16775259461585,
      lon: 145.7750658526996,
    },
    adjustedCoordinates: {
      lat: 15.16775259461585,
      lon: 145.7750658526996,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: LoggerType.HISCAN,
  },
  {
    deploymentId: 'ld00039test',
    serialNo: 'log000039test',
    projectId: testProjectId,
    areaId: testMarkersAreaId,
    deployTime: new Date('2025-03-12').toISOString(),
    location: 'some location',
    customCoordinates: {
      coordinateSystemId: testProjectCoordinateSystemId,
      axis1: 23351.5074,
      axis2: -6565.1278,
    },
    coordinates: {
      lat: 15.16919209222346,
      lon: 145.7752234789539,
    },
    adjustedCoordinates: {
      lat: 15.16919209222346,
      lon: 145.7752234789539,
    },
    lastReachedAt: new Date('2025-03-12').toISOString(),
    reachability: 2,
    reachabilityStatus: CommonStateStatus.Critical,
    deviceStatus: DeviceStatus.Warning,
    batteryVoltage: 3.2,
    batteryVoltageStatus: CommonStateStatus.Warning,
    minTemp: 10,
    minTempStatus: CommonStateStatus.Normal,
    maxTemp: 20,
    maxTempStatus: CommonStateStatus.Normal,
    firmwareVersion: '1.0.0',
    lastServiceAt: new Date('2025-03-12').toISOString(),
    comment: {
      content: 'some comment',
      author: 'John Doe',
      modifiedAt: new Date('2025-03-12').toISOString(),
    },
    devicePictureIds: ['pic1', 'pic2'],
    servingCellId: '283247247',
    loggerType: 'EASYSCAN' as LoggerType,
  },
].map(d => ({
  ...d,
  roundTripTime: d.roundTripTime ?? 320,
  usedBandForMeasurement: d.usedBandForMeasurement ?? 3,
}));
